import { logger } from '@utils/logger.service';
import { catchError, Observable, OperatorFunction, of } from 'rxjs';

export type ObservableRequestMap = Record<string, Observable<unknown>>;

export const logErrorAndReturnNull = <T>(): OperatorFunction<T, T | null> =>
  catchError(error => {
    logger.error(error);
    return of(null);
  });
